import { styled, TextField, Tooltip } from "@mui/material";
import * as React from "react";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export const StyledTextField = styled(TextField)({
  "& .MuiFormLabel-root": {
    display: "flex",
    alignItems: "center",
    "& .myIcon": {
      paddingLeft: "8px",
      order: 999,
    },
  },
  paddingTop: 0,
});

export function InfoLabel({ label, info, tooltipPlacement, iconSize }) {
  return (
    <>
      {label}
      <Tooltip placement={tooltipPlacement} title={info}>
        <HelpOutlineIcon className="myIcon" fontSize={iconSize} />
      </Tooltip>
    </>
  );
}
